<ion-content class="">
  <div class="scroll-content-modal">
    <app-header-modal [title]="route?.name || ('routeModal.collectionRoute' | t)" [showToggle]="true" [showClose]="true"
      [bgColor]="'var(--color-gray-100)'" (toggleHeight)="toggleModalHeight()" (close)="closeModal()">
    </app-header-modal>

    @if (route) {
    <div class="modal-content">
      <div class="card-content">
        <!-- Route Type Badge -->
        <div class="type-badge-section section-margin-2xs">
          <div class="type-badge badge-cuaternary">
            <img class='icon icon-20 icon-cuaternary margin-r-xs' [src]="routeIcon()" alt="Ruta">
            <span class="type-label p p-medium">{{ routeTypeLabel() }}</span>
          </div>
        </div>

        <!-- Address Section + Trust/Source icons -->
        @if (addressString()) {
        <div class="info-row section-margin-2xs clickable" (click)="repointMapOnRoute($event)">
          <div class="row-content address-field">
            <img class='icon icon-cuaternary margin-r-xs icon-20' src="assets/icons/location.svg" alt="Location">
            <p class="row-text p notranslate" translate="no">{{ addressString() }}</p>
            <app-trust-source-badge
              [validation]="route.validation"
              [dataSource]="route.dataSource">
            </app-trust-source-badge>
          </div>
        </div>
        }

        <!-- Description Section -->
        @if (route.description) {
        <div class="description-section section-margin-2xs">
          <app-leer-mas [text]="route.description" [lineClamp]="3" [threshold]="150">
          </app-leer-mas>
        </div>
        }

        <!-- Materials Section -->
        <app-modal-materials-section
          [materialInput]="inputMaterials()"
          [materialOutput]="outputMaterials()">
        </app-modal-materials-section>

        <!-- Schedule Section -->
        @if (route.schedules && route.schedules.length > 0) {
        <div class="schedule-section section-margin-s">
          <div class="section-title margin-b-s">
            <span class="head head-medium text-secondary">{{ 'routeModal.collectionSchedules' | t }}</span>
          </div>
          <app-schedule [scheduleData]="route.schedules" variant="modal" [showStatus]="true" [showHours]="true"
            [showDayPills]="true" customClasses="sub margin-t-s">
          </app-schedule>
        </div>
        }

        <!-- Reference Links + Website -->
        <div class="section-margin-xs">
          <app-links-chips [links]="route.referenceLinks || []" [website]="route.sitio_web" [maxVisible]="4">
          </app-links-chips>
        </div>

        <!-- Contact Information -->
        <app-contact-info [phone]="route.telefono || route.contactPhone"
          (contactAction)="onContactAction($event)">
        </app-contact-info>

        <!-- Action Buttons Slider -->
        <div class="action-slider-section">
          <app-action-buttons-slider [actions]="actionButtons" (actionClick)="onActionButtonClick($event)">
          </app-action-buttons-slider>
        </div>

        <!-- Suggest Edit Button (only when lacking materials, address, or schedule) -->
        @if (showEditButton()) {
        <div class="button-section section-margin-sm">
          <div class="btn-edit push-btn primary-invert-color-button full-width-button btn-sm" (click)="suggestEdit()">
            <button class="inner-button edit p" [title]="'routeModal.suggestEditTitle' | t">
              <img src="assets/icons/edit.svg" class="icon-primary icon-20" alt="">
              <span class='btn-text p-semibold line-clamp-1'>{{ 'routeModal.editAddInfo' | t }}</span>
            </button>
          </div>
        </div>
        }

        <!-- Social Section (reports + status + comments) -->
        <div class="">
          <app-social-section
            [entityId]="route.id"
            entityType="route">
          </app-social-section>
        </div>

      </div>
    </div>
    }
    <div class="spacing-100"></div>
  </div>
</ion-content>

<!-- Action Sheet for Share Options -->
<ion-action-sheet [isOpen]="isActionSheetOpen" [buttons]="actionSheetButtons" (didDismiss)="isActionSheetOpen = false">
</ion-action-sheet>